import Swiper, { Navigation, Thumbs, FreeMode } from "swiper";
import { controlActive } from "./product-videos";

/**
 * SWIPER SLIDER: Thumbs - media product page
 */
const swiperThumbs = new Swiper(".main-product__slider-thumbs", {
  modules: [FreeMode],
  spaceBetween: 6,
  slidesPerView: 'auto',
  watchSlidesProgress: true,
  freeMode: true
});

/**
 * SWIPER SLIDER: Feature images - media product page
 */
export const swiperPrincipal = new Swiper(".main-product__slider-principal", {
  modules: [Navigation, Thumbs],
  spaceBetween: 0,
  slidesPerView: 1,
  thumbs: {
    swiper: swiperThumbs,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  on : {
    init(sw) {
      controlActive(sw)
    },
    slideChange(sw) {
      controlActive(sw);
    },
    transitionEnd(sw) {
      controlActive(sw);
    }
  }
});
